module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Participantes","heading":"Quem deve participar?","paragraph":"Além do seu acervo pessoal, você tem controle também sobre o acervo de alguns dependentes. No caso do acervo %c quem deve participar?"}}')
  delete Component.options._Ctor
}
